import React from "react";
import { NavLink } from "react-router-dom";
import { toast, } from 'react-toastify';
import { Tooltip, } from '@material-ui/core';
import CustomDialog from "../../components/CustomDialog/Dialog.jsx"
import ReactTable from "react-table";
import withStyles from "@material-ui/core/styles/withStyles";
import Assignment from "@material-ui/icons/Assignment";
import EditIcon from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import { fetchData } from '../../utils/handleApi'
import { styles } from './styles'
class ResponseTables extends React.Component {

  state = {
      loading: false,
      arrResInputs: [],
    }
  
  componentDidMount() {
    this.setState({ loading: true })
    fetchData('product/details', 'post', {
      'product_id': this.props.match.params.productId
    })
    .then(data => {
      if(data.err){
        this.setState({ loading: false })
        return toast.error('Some error happened!')
      }
      const { inputs } = data
      let tempResponseInputs = inputs.map(input => {
        return {
          id: input._id,
          input_data: input.input_data,
          actions: (
            <div className="actions-right">
              <NavLink to={`/admin/vendor/${this.props.match.params.vendorId}/lender/${this.props.match.params.lenderId}/response-edit/${this.props.match.params.productId}/response/${input._id}`}>
                <Button
                  justIcon
                  round
                  simple
                  color="success"
                  className="Edit"
                >
                    <Tooltip title="Edit"> 
                  <EditIcon />
                  </Tooltip>
                </Button>{" "}
              </NavLink>
              <Button
                justIcon
                round
                simple
                onClick={() => this.setState({ showDialogForDelete: true, idToDelete: input._id, })}
                color="danger"
                className="remove"
              >
                  <Tooltip title="Delete"> 
                <Close />
                </Tooltip>
              </Button>{" "}
            </div>
          )
        };
      })
      tempResponseInputs.reverse();
      this.setState({
        arrResInputs: tempResponseInputs,
        loading: false,
      })
    })
  }

  handleYes = () => {
    const { idToDelete, arrResInputs } = this.state;
    fetchData('product/deleteResponseInput', 'post', {
      'product_id': this.props.match.params.productId,
      'input_id': idToDelete
    })
    .then(data => {
      if(data.err){
        return this.setState({ showDialogForDelete: false }, () => {
          toast.error('Some error happened!')
        })
      }
      let res_inputs = arrResInputs;
      res_inputs = res_inputs.filter(res_input => res_input.id !== idToDelete);
      this.setState({
        arrResInputs: res_inputs,
        showDialogForDelete: false
      }, () => {
        toast.success('Response Input deleted successfully!')
      });
    })
    
  }
  
  render() {
    const { loading, arrResInputs, showDialogForDelete } = this.state
    const { classes } = this.props;
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader  icon>
              <CardIcon color="success">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Response Input</h4>
              <NavLink to={`/admin/vendor/${this.props.match.params.vendorId}/lender/${this.props.match.params.lenderId}/response-add/${this.props.match.params.productId}`}>
                <Button
                  variant="contained"
                  color="primary"
                  style={{
                    float: 'right',
                    margin: '5px',
                    backgroundColor: "rgb(4, 171, 35)"
                  }}>
                    Add Response Input
                </Button>
              </NavLink>

            <NavLink to={`/admin/vendor/${this.props.match.params.vendorId}/lender/${this.props.match.params.lenderId}/products`}>
              <Button 
                variant="contained"
                color="primary"
                style={{
                  float: 'right',
                  margin: '5px',
                  backgroundColor: "rgb(4, 171, 35)"
                }}
              >
                Back
              </Button>
            </NavLink>
            </CardHeader>
            <CardBody>
              <ReactTable
                loading={loading}
                NoDataComponent={() => !loading && <p style={{textAlign: "center"}}>No Response Input available</p>}
                data={arrResInputs}
                filterable
                columns={[
                  {
                    Header: "Input Data",
                    accessor: "input_data"
                  },
                  {
                    Header: "Actions",
                    accessor: "actions",
                    sortable: false,
                    filterable: false
                  }
                ]}
                defaultPageSize={10}
                minRows={0}
                showPaginationTop
                showPaginationBottom={false}
                className="-striped -highlight"
              />
            </CardBody>
          </Card>
        </GridItem>
        <CustomDialog
          deleteWho="Response Input"
          showDialogForDelete={showDialogForDelete}
          closeDialog={() => this.setState({ showDialogForDelete: false })}
          handleYes={this.handleYes}
        />
      </GridContainer>
    );
  }
}

export default withStyles(styles)(ResponseTables);
